export const API_PATH_ApiClientsBroadcasterPingSubscriptionPost = '/services/broadcaster/apiClientsBroadcasterPingSubscriptionPost';
